import React from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';
import { getPartChangeLabelProps } from '../../FormChangeHistory.utils';

/** How a template part or mapped PDF field changed: Added / Removed / Edited, Moved, Re-bound, …. */
const PartChangeChip = ({ change }) => {
  const { title, variant } = getPartChangeLabelProps(change);

  return (
    <LabelCDS
      dataTestId={FormChangeHistoryTestIds.PART_CHANGE_CHIP}
      size={LabelSize.S}
      title={title}
      variant={variant}
    />
  );
};

PartChangeChip.propTypes = {
  change: PropTypes.string.isRequired,
};

export default PartChangeChip;
